import { onStopPropagation } from '@/utils/helper';

interface LoaderProperties {
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

export default function Loader({ className = '' }: LoaderProperties) {
  return (
    <div
      onClick={onStopPropagation}
      role="presentation"
      className={`${className} fixed inset-0 z-loader flex items-center justify-center`}
    >
      <div className="absolute inset-0 bg-transparent" />
      <div
        className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200"
        style={{ borderTopColor: 'transparent' }}
      />
    </div>
  );
}
